module Meevo.Components.GlobalNav {

    export class MeevoGlobalNav implements ng.IDirective {
        restrict = "E";
        templateUrl = "app/components/globalNav/globalNav.template.html";
        scope = false;

        static factory(): angular.IDirectiveFactory {
            const directive = () => {
                return new MeevoGlobalNav();
            };

            return directive;
        }
    }

    angular.module("meevo.components.globalNav")
        .directive("meevoGlobalNav", MeevoGlobalNav.factory());
}